import { QueryFunctionContext } from '@tanstack/react-query'
import { GetNotificationsReturnType, getUsersNotifications } from 'API/NotificationsService'
import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore'
import { Notification } from 'resources/types'
import { AllowedOverrides } from './queryOptionsUtils.types'

export type getNotificationsOptions = {
	sortBy: keyof Notification;
	sort?: 'asc' | 'desc';
	limitNumber?: number;
	searchTerm?: string;
	lastDocument?: QueryDocumentSnapshot<DocumentData>;
	mode?: 'standard' | 'autocomplete';
};

export const queryKey = 'notifications'
export const queryKeyAutocomplete = 'notifications-autocomplete'

const getNotificationsQueryOptions = ({
	sortBy,
	sort = 'asc',
	limitNumber,
	searchTerm,
	lastDocument,
	mode = 'standard',
}: getNotificationsOptions,
overrides?: AllowedOverrides) => ({
	queryKey: [
		queryKey, {
			sortBy, sort, limitNumber, searchTerm, lastDocument,
		},
	],
	queryFn: async (context: QueryFunctionContext): Promise<GetNotificationsReturnType<Notification>> => {
		const pageParam = context.pageParam as QueryDocumentSnapshot<DocumentData> | undefined
		const finalSearchTerm = mode === 'autocomplete' ? (context?.meta?.searchTerm as string) ?? '' : searchTerm
		const result = await getUsersNotifications(sortBy, sort, limitNumber, finalSearchTerm, pageParam)
		return result
	},
	getNextPageParam: (lastPage: GetNotificationsReturnType<Notification>) => {
		if (limitNumber === undefined) {
			// If limitNumber is undefined, assume there's no limit and always return lastDocument
			return lastPage.lastDocument || null
		}
		// If the number of notifications returned is less than the limit, there are no more pages
		return lastPage.payload.length < limitNumber ? undefined : lastPage.lastDocument || null
	},
	initialPageParam: lastDocument || undefined,
	// safe overrides
	staleTime: 30 * 1000, // Default stale time is 30 seconds
	...overrides,
})

export default getNotificationsQueryOptions
